/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Adjustfailed2Inputs */

const zh_adminsubs_adjustfailed2 = /** @type {(inputs: Adminsubs_Adjustfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点数调整失败`)
};

const en_adminsubs_adjustfailed2 = /** @type {(inputs: Adminsubs_Adjustfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to adjust credits`)
};

const es_adminsubs_adjustfailed2 = /** @type {(inputs: Adminsubs_Adjustfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al ajustar créditos`)
};

/**
* | output |
* | --- |
* | "Failed to adjust credits" |
*
* @param {Adminsubs_Adjustfailed2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_adjustfailed2 = /** @type {((inputs?: Adminsubs_Adjustfailed2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Adjustfailed2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_adjustfailed2(inputs)
	if (locale === "en") return en_adminsubs_adjustfailed2(inputs)
	return es_adminsubs_adjustfailed2(inputs)
});
export { adminsubs_adjustfailed2 as "adminSubs_adjustFailed" }